/**
 * Converts a story title + id into a URL-friendly slug.
 * e.g. "The Dark Below" + "069fbd71" → "the-dark-below-069fbd71"
 */
export const toStorySlug = (title: string, id: string): string => {
  const titleSlug = title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
  return `${titleSlug}-${id}`;
};

/**
 * Extracts the UUID from a slug.
 * e.g. "the-dark-below-069fbd71-0c83-4133-9919-423290d03957" → "069fbd71-0c83-4133-9919-423290d03957"
 */
export const idFromSlug = (slug: string): string => {
  const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const match = slug.match(uuidRegex);
  return match ? match[0] : slug;
};
